module.exports = __webpack_public_path__ + "media/images/alumni/sara-09711acf038577d31111118731f38f6c.png";